import React, { FC, useEffect, useState } from "react";
import classNames from "classnames";
import styles from "./TableBody.module.sass";
import { ProcessListItem } from "../ProcessListItem/ProcessListItem";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { getProcesses } from "toolkit/steps/stepTwo/stepTwo.thunks";
import { getProcessClassesDirectory } from "toolkit/directories/directories.thunks";
import { useLocation, useParams } from "react-router-dom";
import { NoData } from "components-new/NoData/NoData";

export const TableBody: FC = () => {
	const processClassesDirectory = useAppSelector((state) => state.directories.processClassesDirectory);
	const showOnlyCritical = useAppSelector((state) => state.stepTwo.showOnlyCritical);
	const { organizationId } = useParams();
	const processList = useAppSelector((state) => state.stepTwo.processList);
	const location = useLocation();

	const dispatch = useAppDispatch();
	const [processClasses, setProcessClasses] = useState<
		{
			name: string;
			id: number;
			bpCount: number;
		}[]
	>([]);

	useEffect(() => {
		if (organizationId) dispatch(getProcesses(+organizationId));
		if (!processClassesDirectory.length) dispatch(getProcessClassesDirectory());
		//eslint-disable-next-line
	}, []);
	useEffect(() => {
		// if (processList.length) {
		const newProcessClasses: any[] = [];
		processList.forEach((process) => {
			if (newProcessClasses.filter((itemClass) => itemClass.name === process.clazz.name).length) {
				newProcessClasses.filter((itemClass) => itemClass.name === process.clazz.name)[0].bpCount++;
			} else {
				newProcessClasses.push({ name: process.clazz.name, id: Date.now(), bpCount: 1 });
			}
		});
		setProcessClasses(newProcessClasses);
		// }
	}, [processList]);
	const renderBlock = (item: any): React.ReactNode => {
		if (showOnlyCritical) {
			const criticalProcessList = processList.filter(
				(process) => process.clazz.name === item.name && process.criticality,
			);
			return (
				<React.Fragment key={item.id*4}>
					{criticalProcessList.length ? (
						<>
							<tr className={classNames(styles.row, styles.class)} key={item.id}>
								<td rowSpan={criticalProcessList.length + 1} className={styles["item-class"]}>
									{item.name}
								</td>
							</tr>
							{criticalProcessList.map((process) => {
								const className = process.id === location?.state?.outline ? styles.outline : "";
								return <ProcessListItem process={process} className={className} key={process.id} />;
							})}
						</>
					) : (
						""
					)}
				</React.Fragment>
			);
		}
		return (
			<React.Fragment key={item.id * 2}>
				<tr className={classNames(styles.row, styles.class)} key={item.id}>
					<td rowSpan={item.bpCount + 1} className={styles["item-class"]}>
						{item.name}
					</td>
				</tr>
				{processList
					.filter((process) => process.clazz.name === item.name)
					.map((process) => {
						const className = process.id === location?.state?.outline ? styles.outline : "";
						return <ProcessListItem process={process} className={className} key={process.id} />;
					})}
			</React.Fragment>
		);
	};

	return (
		<tbody data-comment-false={true} className={styles.body}>
			{showOnlyCritical ? (
				processList.filter((process) => process.criticality).length ? (
					// <>
						processClasses.filter((item) => item.bpCount).map((item,index) => (<React.Fragment key={index}>{renderBlock(item)}</React.Fragment>))
					// </tbody>
				) : (
					<tr className={styles.rowEmpty}>
						<td colSpan={12}>
							<NoData title="Данные отсутствуют" />
						</td>
					</tr>
				)
			) : processList.length ? (
				// <tbody data-comment-false={true} className={styles.body}>
					processClasses.filter((item) => item.bpCount).map((item,index) => (<React.Fragment key={index}>{renderBlock(item)}</React.Fragment>))
				// </tbody>
			) : (
				<tr className={styles.rowEmpty}>
					<td colSpan={12}>
						<NoData title="Данные отсутствуют" />
					</td>
				</tr>
			)}
		</tbody>
	);
};
